import { Forbidden } from './forbidden.error';
import { Unauthorized } from './unauthorized.error';

export const ErrorCodes = {
  Forbidden,
  Unauthorized,
} as const;

export const ErrorCodesByStatus = {
  [403]: {
    [Forbidden.GUEST_ORDER_MISMATCH]: 'This order is not available for the current session',
  },
  [401]: {
    [Unauthorized.BAD_CREDENTIALS]: 'Bad credentials',
    [Unauthorized.DISABLED]: 'Disabled user',
    [Unauthorized.GUEST_TOKEN_EXPIRED]: 'Guest session has expired',
    [Unauthorized.WRONG_APPLICATION]: 'User has not been granted access to this application',
  },
};

export type ErrorCodeValues = (typeof ErrorCodes)[keyof typeof ErrorCodes];
export type UnauthorizedValues = (typeof ErrorCodes.Unauthorized)[keyof typeof ErrorCodes.Unauthorized];
export type ForbiddenValues = (typeof ErrorCodes.Forbidden)[keyof typeof ErrorCodes.Forbidden];
